import React, {Component} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText,
    FlatList,
    Image,
    Modal,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import AppConfig from '../../../AppConfig';

import {connect} from 'react-redux';

import TBusinessScreen from './Translations/TBusinessScreen';

import RestaurantItem from '../../../components/admin/Business/RestaurantItem';
import {FormModal} from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import Styles from '../../../Styles';
import DefaultButton, {DarkButton, ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import ImageIcon from "../../../assets/custom-icons/ImageIcon";

function mapStateToProps(state) {
    return {
        Auth: state.Auth
    }
}

export const authScreenOptions = ({navigation}) => {
    return {
        title: 'Login',
    }
}

class BusinessScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            logoLoading: false,
            isLogoModalOpen: false,
            isNewRestaurantModalOpen: false,
            isMenuPickerOpen: false,
            business: {},
            restaurants: [],
            menus: [],
            menuOptions: [],
            form: {
                controls: {
                    RES_NAME: {
                        elementType: 'input',
                        elementConfig: {
                            placeholder: TBusinessScreen[AppConfig.lang].NAME,
                            autoCapitalize: 'words'
                        },
                        label: TBusinessScreen[AppConfig.lang].NAME + '*',
                        value: '',
                        errorMessage: '',
                        validation: {
                            required: true
                        },
                        valid: false,
                        touched: false,
                    },
                    RES_COUNTRY_ID: {
                        elementType: 'select',
                        elementConfig: {
                            placeholder: TBusinessScreen[AppConfig.lang].COUNTRY,
                        },
                        label: TBusinessScreen[AppConfig.lang].COUNTRY + '*',
                        value: '',
                        options: [],
                        errorMessage: '',
                        validation: {
                            required: true
                        },
                        onChangeCallback: async (event) => {
                            const form = {...this.state.form}
                            let controls = {...form.controls}
                            controls.RES_COUNTRY_ID.value = event.value;

                            this.setState({
                                form: {
                                    controls: controls,
                                    isValidForm: false
                                }
                            })

                            const response = await fetch(AppConfig.URL + '/PublicActions/FetchStates/' + event.value, {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                }
                            );

                            let data = await response.json();

                            controls = {...form.controls}

                            const RES_STATE_ID = {...controls.RES_STATE_ID}

                            RES_STATE_ID.value = ""
                            RES_STATE_ID.options = []

                            for (let i = 0; i < data.states.length; i++)
                                RES_STATE_ID.options.push({
                                    label: data.states[i].stA_NAME,
                                    value: data.states[i].stA_ID
                                });

                            controls.RES_STATE_ID = RES_STATE_ID;
                            form.controls = controls;

                            form.isValidForm = false;

                            this.setState({
                                form: form,
                                states: data.states
                            })
                        }
                    },
                    RES_STATE_ID: {
                        elementType: 'select',
                        label: TBusinessScreen[AppConfig.lang].STATE,
                        elementConfig: {
                            multiline: true,
                            type: 'text',
                            placeholder: TBusinessScreen[AppConfig.lang].STATE,
                            autoCapitalize: 'none'
                        },
                        value: '',
                        options: [],
                        validation: {
                            required: true
                        },
                    },
                    RES_CITY: {
                        elementType: 'input',
                        label: TBusinessScreen[AppConfig.lang].CITY,
                        elementConfig: {
                            multiline: true,
                            type: 'text',
                            placeholder: TBusinessScreen[AppConfig.lang].CITY,
                            autoCapitalize: 'none'
                        },
                        value: '',
                        validation: {
                            required: true
                        },
                    },
                    RES_LOCATION: {
                        elementType: 'input',
                        label: TBusinessScreen[AppConfig.lang].LOCATION,
                        elementConfig: {
                            multiline: true,
                            type: 'text',
                            placeholder: TBusinessScreen[AppConfig.lang].LOCATION,
                            autoCapitalize: 'none'
                        },
                        value: '',
                        validation: {
                            required: true
                        },
                    },
                    RES_DESCRIPTION: {
                        elementType: 'input',
                        label: TBusinessScreen[AppConfig.lang].DESCRIPTION,
                        elementConfig: {
                            multiline: true,
                            type: 'text',
                            placeholder: TBusinessScreen[AppConfig.lang].DESCRIPTION,
                            autoCapitalize: 'none'
                        },
                        value: '',
                        validation: {
                            required: false
                        },
                    },
                },
            },
            Auth: {}
        };

        this.ToggleLogoModal = this.ToggleLogoModal.bind(this);
        this.ToggleNewRestaurantModal = this.ToggleNewRestaurantModal.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {

    }

    render() {

        return (<View>
                <View
                    style={{marginBottom: 15, flexDirection: 'row', justifyContent: 'space-between'}}
                >
                    <h1>
                        {TBusinessScreen[AppConfig.lang].MY_BUSINESS}
                    </h1>
                    <ThemeButton
                        text={TBusinessScreen[AppConfig.lang].ADD_RESTAURANT}
                        onPress={this.ToggleNewRestaurantModal.bind(this)}
                    />
                </View>
                {true || this.props.Auth.role != 'Bow' ?
                    null
                    :
                    <View style={{marginBottom: 15, justifyContent: 'space-between', ...Styles.flexDirectionRow}}>
                        <View style={{
                            flex: 1,
                            justifyContent: 'flex-end', ...Styles.flexDirectionRow,
                            alignItems: 'end'
                        }}>
                            {this.props.Auth.sub &&
                            (
                                this.props.Auth.sub.code == AppConfig.SUB_STANDARD
                                ||
                                this.props.Auth.sub.code == AppConfig.SUB_PREMIUM
                            ) ?
                                <DefaultButton
                                    text={TBusinessScreen[AppConfig.lang].LOGO}
                                    onPress={this.ToggleLogoModal.bind(this)}
                                />
                                :
                                null
                            }
                        </View>
                    </View>
                }

                <View
                    className={'card-desktop'}
                >
                    <View
                        className={'card-body'}
                        style={{
                            paddingTop: 0, paddingBottom: 0
                        }}
                    >
                        <View className="row hide-mobile">
                            <View className="col-12 col-md-12">
                                <View className="row">
                                    <View className="col-12 col-md-2 col-lg-2 th">
                                        <CCText>
                                            {TBusinessScreen[AppConfig.lang].NAME}
                                        </CCText>
                                    </View>
                                    <View className="col-12 col-md-6 col-lg-7 th">
                                        <CCText>
                                            {TBusinessScreen[AppConfig.lang].LOCATION}
                                        </CCText>
                                    </View>
                                    <View className="col-12 col-md-4 col-lg-3 padding-mobile th"
                                          style={{justifyContent: 'flex-end', flexDirection: 'row'}}>

                                    </View>
                                </View>
                            </View>
                        </View>
                        {this.state.loading ? <ActivityIndicator style={{marginTop: 15, marginBottom: 15}}/> : null}
                        <FlatList
                            keyboardShouldPersistTaps={'always'}
                            maxToRenderPerBatch={8}
                            windowSize={15}
                            style={{height: '100%'}}
                            keyExtractor={item => {
                                return item.reS_ID;
                            }}
                            data={this.state.restaurants}
                            renderItem={({item}) => <View style={{}}>
                                <RestaurantItem
                                    item={item}
                                    Auth={this.props.Auth}
                                    countries={this.state.countries}
                                    states={this.state.states}
                                />
                            </View>}
                        />
                        <Modal
                            visible={this.state.isLogoModalOpen}
                            onRequestClose={this.ToggleLogoModal.bind(this)}
                        >
                            <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                                <View>
                                    <CCText style={{fontWeight: 'bold', textAlign: 'center', fontSize: 26}}>
                                        {TBusinessScreen[AppConfig.lang].LOGO}
                                    </CCText>
                                    <View style={{padding: 15}}>
                                        {this.state.logoLoading ? <ActivityIndicator/> :
                                            this.state.business.buS_LOGO ?
                                                <View>
                                                    <Image source={{uri: this.state.business.buS_LOGO}} style={{
                                                        backgroundColor: 'white',
                                                        width: 300,
                                                    }}
                                                    />
                                                </View>
                                                :
                                                <View style={{
                                                    justifyContent: 'center',
                                                    flexDirection: 'row',
                                                    width: 300,
                                                    height: 300,
                                                    backgroundColor: '#404040'
                                                }}>
                                                    <View style={{justifyContent: 'center'}}>
                                                        <ImageIcon color={'white'} size={20}/>
                                                    </View>
                                                </View>
                                        }
                                    </View>
                                </View>
                                <DarkButton
                                    text={TBusinessScreen[AppConfig.lang].CHANGE}
                                    onPress={this.clickImageInput.bind(this)}
                                />
                                <input
                                    ref={(r) => this.inputFile = r}
                                    style={{display: 'none'}}
                                    type="file"
                                    name="item"
                                    accept=".png,.jpg,.jpeg"
                                    onChange={this.ChangeLogo.bind(this)}
                                />
                            </View>
                        </Modal>
                        <FormModal
                            title={TBusinessScreen[AppConfig.lang].ADD_RESTAURANT}
                            form={this.state.form}
                            isOpen={this.state.isNewRestaurantModalOpen}
                            toggle={this.ToggleNewRestaurantModal.bind(this)}
                            confirmFunction={async () => {
                                const form = {...this.state.form}
                                const controls = {...form.controls}

                                if (this.state.form.isValidForm) {
                                    let formData = {};

                                    for (let key in controls)
                                        formData[key] = controls[key].value;

                                    const response = await fetch(AppConfig.URL + "/Restaurant/Create", {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json',
                                            'Authorization': this.props.Auth.token
                                        },
                                        body: JSON.stringify(formData)
                                    });

                                    const json = await response.json();

                                    if (json.success) {
                                        const restaurants = [...this.state.restaurants];

                                        restaurants.push(json.restaurant);

                                        this.setState({
                                            restaurants: restaurants,
                                            isNewRestaurantModalOpen: false
                                        });

                                    } else {
                                        if (json.msg) {
                                            form.generalError = {
                                                text: json.msg,
                                                show: true
                                            }

                                            this.setState({
                                                form: form
                                            })
                                        }
                                    }
                                } else {
                                    this.setState({
                                        isNewRestaurantModalOpen: false
                                    });
                                }
                            }}
                            confirmText={TBusinessScreen[AppConfig.lang].SAVE}
                            cancelText={TBusinessScreen[AppConfig.lang].CANCEL}
                            onFormChange={(updatedForm) => {
                                this.setState({
                                    form: updatedForm
                                })
                            }}
                        />
                    </View>
                </View>
            </View>
        );
    }

    async fetchData() {
        try {
            const response = await fetch(AppConfig.URL + '/Business/Index/', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.props.Auth.token
                    },
                }
            );

            let data = await response.json();

            if (!data.business.buS_CONFIGURED) {
                window.location.href = '/admin/setup'

                return;
            }

            const locationResponse = await fetch(AppConfig.URL + '/PublicActions/AvailableCountries/', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            let locationData = await locationResponse.json();

            const statesResponse = await fetch(AppConfig.URL + '/PublicActions/FetchStates/' + locationData.defaultCountry.coU_ID, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );

            let statesData = await statesResponse.json();

            const form = {...this.state.form}
            const controls = {...form.controls}
            const RES_COUNTRY_ID = {...controls.RES_COUNTRY_ID}
            const RES_STATE_ID = {...controls.RES_STATE_ID}

            RES_COUNTRY_ID.value = locationData.defaultCountry.coU_ID;

            for (let i = 0; i < locationData.countries.length; i++)
                RES_COUNTRY_ID.options.push({
                    label: locationData.countries[i].coU_NAME,
                    value: locationData.countries[i].coU_ID
                });

            controls.RES_COUNTRY_ID = RES_COUNTRY_ID;

            for (let i = 0; i < statesData.states.length; i++)
                RES_STATE_ID.options.push({
                    label: statesData.states[i].stA_NAME,
                    value: statesData.states[i].stA_ID
                });

            controls.RES_STATE_ID = RES_STATE_ID;
            form.controls = controls;

            this.setState({
                form: form,
                business: data.business,
                restaurants: data.restaurants,
                countries: locationData.countries,
                defaultCountry: locationData.defaultCountry,
                states: statesData.states,
                loading: false,
            });


            return;
        } catch (error) {
            console.log(error);

            this.setState({
                loading: false
            });
        }

    }

    clickImageInput() {
        this.inputFile.click();
    }

    async ChangeLogo(event) {
        if (event.target.files.length > 0) {
            this.setState({
                logoLoading: true
            })

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });

            const image = await toBase64(event.target.files[0]);

            const response = await fetch(AppConfig.URL + "/Business/UploadLogo", {
                method: 'POST',
                body: JSON.stringify({
                    Image: image,
                    Type: 'HQ'
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.props.Auth.token
                }
            });

            const r = await response.json();

            if (r.success) {
                const business = {...this.state.business};

                business.buS_LOGO = image;

                this.setState({
                    business: business
                });
            }

            this.setState({
                logoLoading: false
            })
        }
    }

    ToggleLogoModal() {
        this.setState(
            (prevState) => ({isLogoModalOpen: !prevState.isLogoModalOpen}),
        );
    }

    ToggleNewRestaurantModal() {
        this.setState(
            (prevState) => ({isNewRestaurantModalOpen: !prevState.isNewRestaurantModalOpen}),
        );
    }
}

export default connect(mapStateToProps)(BusinessScreen);